module.exports = __webpack_public_path__ + "static/garra-logo-5e1069438bb03fb0713178d08948e8ce.png";